import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

/**
 * Reveal — scroll-triggered fade-up wrapper (framer-motion).
 * Restrained, plays once when the element enters the viewport.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  className = '',
  once = true,
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration: 0.6, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
